<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle" stepSize="sm">

      <tab-content title="">
        <LessonTabContent>
            <span class="font-black text-6xl">Reality check</span>

          <div class="lesson-intro-image-wrapper">
             <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_0.svg"/>
          </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>


            <div class="pt-4">
               Before we focus on your development and self-knowledge, it's time for a short <span class="font-semibold">reality check</span> to explore how you're doing so far.
            </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
            <div class="lg:w-1/2 mx-auto">
              <img src="@/assets/images/academy/aca_1.png"/>
            </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

        <p>You have spent your time in many different ways, you have certainly met a lot of goals, you have learned a lot, whether consciously or not.</p>

        <p class="mt-4">
          But how much are you able to <span class="font-semibold">evaluate it objectively?</span>
        </p>
             <!-- <img class="w-1/2 mx-auto p-4" src="@/assets/images/academy/academy_popup_0.svg"/> -->


        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

            <p class="">Being true to yourself is the first step, and creating the right data for your future self is the second step. </p>

         <p class="mt-4 font-semibold">So go for it.</p>


        </LessonTabContent>
      </tab-content>

      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
          <div class="md:flex pt-4">
            <div class="pr-2 w-full md:w-1/2">
                <RealityCheckItem class="mb-4" v-model="lessonData.sleep" title="I get enough sleep at night"/>
               <RealityCheckItem class="mb-4" v-model="lessonData.energy" title="I feel energized"/>
               <RealityCheckItem class="mb-4" v-model="lessonData.midful" title="I feel peaceful and mindful"/>
               <RealityCheckItem class="mb-4" v-model="lessonData.distractions" title="I am not easily distractable"/>
            </div>

            <div class="pl-2 w-full md:w-1/2">
              <RealityCheckItem class="mb-4" v-model="lessonData.rest" title="I wake up well-rested"/>
              <RealityCheckItem class="mb-4" v-model="lessonData.fitness" title="I feel fit"/>
               <RealityCheckItem class="mb-4" v-model="lessonData.goals" title="I know my long-term goals"/>
               <RealityCheckItem class="mb-4" v-model="lessonData.monday" title="I love mondays"/>
            </div>
          </div>

        </LessonTabContent>
      </tab-content>
    </form-wizard>
  </LessonContent>
</template>

<script>
import LessonContent from './LessonContent'
import RealityCheckItem from './RealityCheckItem'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    RealityCheckItem,
    FormWizard,
    LessonTabContent,
    TabContent
  },
  props: ['lesson'],
  data () {
    return {
      lessonData: {
        sleep: null,
        energy: null,
        midful: null,
        distractions: null,
        rest: null,
        fitness: null,
        goals: null,
        opportunities: null,
        monday: null,
      }
    }
  },
  computed: {
    completedFinishButton () { return 'save' },
  },
  mixins: [LessonMixin],
  methods: {
  },
}

</script>
